import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { CheckCircle, HouseLine, IdentificationCard, PaperPlaneTilt, Phone, User } from '@phosphor-icons/react'
import KioskHeader from '../../components/KioskHeader/KioskHeader'
import useKioskAutoHome from '../../hooks/useKioskAutoHome'
import logo from '../../assets/images/logo.png'

export default function JoinPbbPage() {
  useKioskAutoHome()
  const navigate = useNavigate()

  const [name, setName] = useState('')
  const [phone, setPhone] = useState('')
  const [email, setEmail] = useState('')
  const [birthYear, setBirthYear] = useState('')
  const [address, setAddress] = useState('')
  const [submitted, setSubmitted] = useState(false)

  const canSubmit = name.trim() && phone.trim() && birthYear.trim() && address.trim()

  const [phoneError, setPhoneError] = useState('')

  const handlePhoneChange = (e) => {
    let value = e.target.value.replace(/\D/g, '')

    // Malaysia mobile length
    if (value.length > 11) {
      value = value.slice(0, 11)
    }

    setPhone(value)

    if (!value) {
      setPhoneError('Phone number is required')
    } else if (value.length < 9) {
      setPhoneError('Invalid phone number')
    } else {
      setPhoneError('')
    }
  }

  const handleSubmit = (event) => {
    event.preventDefault()
    if (!canSubmit) return

    // TODO: connect to backend API
    // Example payload: { name, phone, email, birthYear, address, source: 'kiosk' }

    setSubmitted(true)
    window.setTimeout(() => {
      navigate('/', { replace: true })
    }, 3500)
  }

  return (
    <main className="kiosk-page join-pbb-page">
      <div className="app-container kiosk-container">
        <KioskHeader title="Join PBB Member" subtitle="Berkhidmat Untuk Rakyat" />

        <section className="join-pbb-card">
          {!submitted ? (
            <form onSubmit={handleSubmit}>
              <div className="join-pbb-card__brand">
                <img src={logo} alt="PBB N22 Kedup" />
                <span>N22 Kedup</span>
              </div>

              <div className="join-pbb-card__header">
                <span className="join-pbb-card__icon"><IdentificationCard size={30} /></span>
                <div>
                  <h1>Berkhidmat Untuk Rakyat</h1>
                  <p>Register your interest to join PBB N22 Kedup. Our team will contact you for the next step.</p>
                </div>
              </div>

              <div className="join-pbb-form">
                <div className="form-group">
                  <label className="form-label"><User size={15} /> Name / Nama <strong>*</strong></label>
                  <input
                    className="form-input"
                    value={name}
                    onChange={(event) => setName(event.target.value)}
                    placeholder="eg. Martin / contoh. Martin"
                  />
                </div>

                <div className="form-group">
                  <label className="form-label"><Phone size={15} /> Phone Number / Nombor Telefon <strong>*</strong></label>
                  <div className="phone-input phone-input--malaysia">
                    <div className="phone-input__prefix">
                      🇲🇾 +60
                    </div>

                    <input
                      type="tel"
                      inputMode="numeric"
                      className={`phone-input__number ${phoneError ? 'is-error' : ''}`}
                      placeholder="161234567"
                      value={phone}
                      onChange={handlePhoneChange}
                    />
                  </div>

                  {phoneError && (
                    <div className="form-error">
                      {phoneError}
                    </div>
                  )}
                </div>

                <div className="form-group">
                  <label className="form-label">Email</label>
                  <input
                    className="form-input"
                    type="email"
                    inputMode="email"
                    value={email}
                    onChange={(event) => setEmail(event.target.value)}
                    placeholder="eg. n22kedup@gmail.com / contoh. n22kedup@gmail.com"
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">Year of birth / Tahun lahir <strong>*</strong></label>
                  <input
                    className="form-input"
                    type="number"
                    inputMode="numeric"
                    value={birthYear}
                    onChange={(event) => setBirthYear(event.target.value)}
                    placeholder="eg. 1985"
                  />
                </div>

                <div className="form-group form-group--full">
                  <label className="form-label"><HouseLine size={15} /> Residence Address / Alamat Rumah <strong>*</strong></label>
                  <textarea
                    className="form-textarea"
                    rows={5}
                    value={address}
                    onChange={(event) => setAddress(event.target.value)}
                    placeholder="eg. Lot 358, Jalan Kuching, 94700 Serian."
                  />
                </div>
              </div>

              <div className="join-pbb-actions">
                <button type="button" className="btn btn--ghost" onClick={() => navigate('/')}>Back to Home</button>
                <button type="submit" className="btn btn--primary join-pbb-submit" disabled={!canSubmit}>
                  <PaperPlaneTilt size={18} /> Join Us / Sertai PBB
                </button>
              </div>
            </form>
          ) : (
            <div className="kiosk-success-state join-pbb-success">
              <CheckCircle size={58} />
              <h1>Thank you.</h1>
              <p>Your registration interest has been submitted. Our team will contact you shortly.</p>
            </div>
          )}
        </section>
      </div>
    </main>
  )
}
